import React from "react";

export const SwiperButton: React.FC<{ direction: "left" | "right" }> = ({
  direction,
}) => (
  <div className={`swiper-button ${direction}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="100%"
      height="100%"
    >
      {direction === "left" ? (
        <path d="M28.05 36 16 23.95 28.05 11.9l2.15 2.15-9.9 9.9 9.9 9.9Z" />
      ) : (
        <path d="M18.75 36 16.6 33.85 26.5 23.95 16.6 14.05 18.75 11.9 30.8 23.95Z" />
      )}
    </svg>
  </div>
);
